import { h, Component, render } from "preact";
import style from "./style";
import { constants } from "../../config";
import { getEngagements } from '../../helper';

// const icon_path = "../../../assets/socialEmoji/";
export default class SocialEmotionIcons extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emotionSelected: null
    };
  }
  render(props, state) {
    const { tag, size } = props;
    const title = tag && tag.details && tag.details.title;
    const engagement =
      tag.details && tag.details.engagements && tag.details.engagements[0];
    const layout = props.layout || (engagement && engagement.layout) || "black";
    const attr = engagement && engagement.attr && JSON.parse(engagement.attr);
    const enabledAttr = attr && attr.filter(item => item.enabled);
    const hideTitle = engagement && !!engagement.hide_title;
    const tagColor = (tag && tag.details && tag.details.color) || "#ffffff";
    return (
      <div class={`wt-social-emotion-container`}>
        {!hideTitle && (
          <div class={`wt-social-emotion-title`} style={{ color: tagColor, textAlign: size ? 'center': 'auto' }}>
            {title}
          </div>
        )}
        <ul class={`wt-social-emotion ${layout} ${size || ""}`}>
          {enabledAttr &&
            enabledAttr.map((icon, idx) => {
              let emojiStyle = {
                // background: `url(${icon_path}${icon.name}.svg)`,
                backgroundSize: "cover",
                width: "100%",
                height: "100%"
              };
              if (state.emotionSelected) {
                if (state.emotionSelected === icon.name) {
                  emojiStyle = { ...emojiStyle, transform: "scale(1.5)" };
                } else {
                  emojiStyle = { ...emojiStyle, opacity: "0.5" };
                }
              }
              return (
                <li
                  key={`icon-${idx}`}
                  onClick={this.handleEmotionIconClick.bind(this, icon)}
                >
                  <div style={emojiStyle} class={`emoji_${icon.name}`} />
                </li>
              );
            })}
        </ul>
      </div>
    );
  }

  handleEmotionIconClick = icon => {
    this.setState({ emotionSelected: icon.name }, () => {
      if (this.props.onEmotionIconClick) {
        this.props.onEmotionIconClick(this.props.tag, icon.name);
      }
      // track thirdparty events---
      this.props.trackEvent("LeadTagEvents", this.props.tag, {
        emotion: icon.name
      });
      //---
      this.logEngagementEvent(icon.name); // emotion specific engagement event
      this.logEngagementEvent(icon.name, 'engagement');
    });
  };

  logEngagementEvent = (name, event) => {
    let engagements = getEngagements(this.props.tag);
    let action = engagements && engagements[0];
    let actionValueFormtted = action.slug || "emotion";

    let tag_id = this.props.tag.id;
    let tag_label =
      this.props.tag &&
      this.props.tag.details &&
      (this.props.tag.details.preview_title || this.props.tag.details.title);
    let engagement_id = action && action.id;

    let options = {
      type: actionValueFormtted,
      sub_type: null,
      event: event || "emotion_engagement",
      event_type: actionValueFormtted,
      tag_id,
      tag_label,
      engagement_id,
      emotion: name,
      current_duration: this.props.getCurrentTime()
    };
    this.props.eventBus(constants.LOG_EVENT_ENGAGEMENT, {
      tag: this.props.tag,
      options
    });
  };
}



// WEBPACK FOOTER //
// ./components/spareparts/socialEmotionIcons/index.js